import styled from "styled-components";

export const AccountPanel = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AccountPanelInner = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.column ? "column" : "row")};
  width: 100%;
  margin-right: 65px;
`;
